/**
 * Created by tomere on 20/12/2017.
 */
export default class DeleteEntityService {
	constructor(JFrogModal) {
		this.JFrogModal = JFrogModal;
	}

	openDeleteModal(deleteParams) {
		if(!deleteParams){
			return;
		}
		this.deleteParams = deleteParams;
		let message = this.deleteParams.deleteMessage ? this.deleteParams.deleteMessage :
			'Are you sure you want to delete ' + this.deleteParams.deleteTargetElementName + '?';
		this.JFrogModal.confirm(message)
		    .then(() => {
			    this.delete();
		    });
	}

	delete() {
		this.deleteParams.deleteAction(this.deleteParams.deleteActionPathParams, this.onDeleteSuccess.bind(this),this.onDeleteFail.bind(this));
	}

	// Delegate onSuccess and onFailure to consuming code
	onDeleteSuccess() {
		if (this.deleteParams.deleteSuccessCallback) {
			this.deleteParams.deleteSuccessCallback();
		}
	}

	onDeleteFail() {
		if (this.deleteParams.deleteFailCallback) {
			this.deleteParams.deleteFailCallback();
		}
	}
}
DeleteEntityService.META = {
	name: 'DeleteEntity'
};
DeleteEntityService.$inject = ['JFrogModal'];


// WEBPACK FOOTER //
// ./modules/distribution/services/delete.entity.service.js